module.exports = __webpack_public_path__ + "img/carousel2.a8a1061f.png";